import { useEffect } from "react";
import { ICaptchaProvider, CaptchaProps } from "./ICaptchaProvider";

const McaptchaComponent: React.FC<CaptchaProps> = ({ onToken }) => {
  useEffect(() => {
    const handler = (event: MessageEvent) => {
      if (event.data?.token) {
        onToken(event.data.token);
      }
    };

    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, [onToken]);

  return (
    <iframe
      title="mCaptcha"
      src={`https://demo.mcaptcha.org/widget?sitekey=${window._env_?.MCAPTCHA_SITE_KEY}`}
      style={{
        border: "none",
        width: "100%",
        height: "80px",
      }}
    />
  );
};

export const McaptchaProvider: ICaptchaProvider = {
  Component: McaptchaComponent,
};
